<template>
  <div class="dialog-wrap">
    <el-dialog title="用户编辑"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="昵称"
                      prop="nickname">
          <el-input v-model="dataForm.nickname"
                    disabled
                    placeholder="输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="手机号"
                      prop="mobile">
          <el-input v-model="dataForm.mobile"
                    placeholder="输入用户手机号"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名"
                      prop="realname">
          <el-input v-model="dataForm.realname"
                    placeholder="输入用户真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="用户分组"
                      prop="category_id">
          <el-select v-model="dataForm.category_ids"
                     multiple
                     placeholder="请选择用户分组"
                     style="width: 100%;">
            <el-option v-for="item in categorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="帐号状态"
                      prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { memberUpdate, memberCategoryList } from '@/api/member'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {
        status: true,
      },
      categorys: [],
      rules: {
        nickname: [
          { required: false, message: '请输入用户昵称', trigger: 'blur' },
        ],
        mobile: [
          {
            required: true,
            message: '请输入用户手机号',
            trigger: 'blur',
            pattern: /^[0-9]{11}$/,
          },
        ],
        password: [
          {
            required: true,
            message: '请输入用户登录密码',
            trigger: 'blur',
            min: 6,
          },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchCategoryList()
      }
    },
    content(val) {
      this.dataForm = val
      if (val.category_ids) {
        this.dataForm.category_ids = val.category_ids
          .split(',')
          .map((v) => Number(v))
      }
    },
  },
  methods: {
    fetchCategoryList() {
      memberCategoryList({ isPaging: 0 }).then((res) => {
        this.categorys = res.list
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = {
            id: this.dataForm.id,
            realname: this.dataForm.realname,
            category_ids: this.dataForm.category_ids
              ? this.dataForm.category_ids.join(',')
              : '',
            status: this.dataForm.status ? 1 : 0,
            mobile: this.dataForm.mobile,
          }
          memberUpdate(params)
            .then((res) => {
              this.$message.success(`编辑成功`)
              this.$refs['dataForm'].resetFields()

              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
